import { useApi } from './api';

export const useMatchDetails = (id, season) =>
  useApi(`match?id=${id}&season=${season}`);

export const useLineup = (id, season) =>
  useApi(`lineups?id=${id}&season=${season}`);

export const useMatchStats = (id, season) =>
  useApi(`matchstats?id=${id}&season=${season}`);

export const useMatchConfig = (id, season) =>
  useApi(id && season && `match-config?id=${id}&season=${season}`);
